module.exports = __webpack_public_path__ + "media/images/b2b_admin/trip_details_shortcut_icon-4fa95945808030780aed8bc39b41e5ba.svg";